export function buildPartsItemsFromTicket(ticket) {
  const baseItem = {
    id: Date.now(),
    part_code: ticket.part_code || '',
    part_name: ticket.part_name || '',
    parts_price: '',
  };

  let extraParts = [];
  if (Array.isArray(ticket.extra_parts)) {
    extraParts = ticket.extra_parts;
  } else if (ticket.extra_parts) {
    try {
      extraParts = JSON.parse(ticket.extra_parts);
    } catch {
      extraParts = [];
    }
  }

  const totalPartsPrice = parseFloat(ticket.parts_price || 0) || 0;
  const extraPriceTotal = extraParts.reduce((sum, p) => sum + (parseFloat(p.parts_price) || 0), 0);
  const firstPartPrice = extraParts.length ? Math.max(totalPartsPrice - extraPriceTotal, 0) : totalPartsPrice;

  return [
    {
      ...baseItem,
      parts_price: firstPartPrice > 0 ? firstPartPrice.toFixed(2) : '',
    },
    ...extraParts.map((p) => ({
      ...p,
      id: Date.now() + Math.random(),
      part_code: p.part_code || '',
      part_name: p.part_name || '',
      parts_price: parseFloat(p.parts_price) || '',
    })),
  ];
}
